import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@/components/atoms";
import { useAppAbility } from "@/casl";
import { isOldVmRetired, isOperatorCreatedAfterMigration, OLD_VM_RETIREMENT_DATE_FORMATTED } from "@/constants/vehicleMigration";
import { useLayout, useOperator } from "@/hooks";
import { useVehicleTypeMigrationCheck } from "@/hooks/useVehicleTypeMigrationCheck";
import { clsx } from "@/utils";

export const VehicleMigrationBanner = () => {
  const navigate = useNavigate();
  const ability = useAppAbility();
  const { id: operatorId, joined } = useOperator();
  const {
    layout: { sidebarOpen },
  } = useLayout();
  const { needsMigration: needsTypeMigration, valid, total, isReady } = useVehicleTypeMigrationCheck();

  const canAccessVehicleManager = ability.can("manage", "providerVehicleManager");

  if (isOldVmRetired() || !isReady || !canAccessVehicleManager || isOperatorCreatedAfterMigration(joined)) return null;

  if (needsTypeMigration) {
    return (
      <div className="relative top-0 z-40 bg-danger px-5 py-1 text-white transition-all duration-200">
        <div
          className={clsx(
            "mx-auto flex max-w-screen-2xl flex-row items-center justify-between gap-4 transition-all duration-200",
            sidebarOpen ? "lg:pl-[250px]" : "lg:pl-[65px]"
          )}
        >
          <Typography variant="action" className="text-white">
            Old Vehicle Manager is retiring on {OLD_VM_RETIREMENT_DATE_FORMATTED}. Set up Vehicle Types ({valid}/{total}) to move your
            vehicles to the new one
          </Typography>
          <Button
            variant="custom"
            size="sm"
            className="flex-shrink-0 text-white underline"
            onClick={() => navigate(`/operator/${operatorId}/config/trip/vehicle-types`)}
          >
            Go to Vehicle Types →
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative top-0 z-40 bg-danger px-5 py-1 text-white transition-all duration-200">
      <div
        className={clsx(
          "mx-auto flex max-w-screen-2xl flex-row items-center justify-between gap-4 transition-all duration-200",
          sidebarOpen ? "lg:pl-[250px]" : "lg:pl-[65px]"
        )}
      >
        <Typography variant="action" className="text-white">
          Old Vehicle Manager is retiring on {OLD_VM_RETIREMENT_DATE_FORMATTED}. Move your vehicles to the new one
        </Typography>
        <Button
          variant="custom"
          size="sm"
          className="flex-shrink-0 text-white underline"
          onClick={() => navigate(`/operator/${operatorId}/vehicles-legacy`)}
        >
          Transfer Vehicles →
        </Button>
      </div>
    </div>
  );
};
